export const tvSeries = [
  {
    id: "t1",
    title: "山河故梦",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20an%20ancient%20chinese%20palace%20courtyard%20with%20a%20scholar%20in%20traditional%20robes%2C%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-01&orientation=portrait",
    year: 2024,
    genres: ["古装", "历史", "剧情"],
    region: "中国大陆",
    rating: 8.9,
    episodes: 40,
    director: "孔笙",
    actors: ["胡歌", "刘涛", "王凯"],
    synopsis: "一纸任命，将年轻的文臣陆知舟推向了动荡的朝局中心。他在家国理想与个人情感之间反复权衡，用半生岁月守护一方山河。全剧以恢弘的笔触，描绘了那个风云激荡时代里普通人的命运。",
    tags: ["古装", "历史", "权谋"],
    hot: 96,
  },
  {
    id: "t2",
    title: "都市脉络",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20a%20businessman%20silhouette%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-02&orientation=portrait",
    year: 2023,
    genres: ["都市", "剧情"],
    region: "中国大陆",
    rating: 8.1,
    episodes: 36,
    director: "刘俊杰",
    actors: ["雷佳音", "袁泉", "张新成"],
    synopsis: "一家老牌企业面临转型危机，三代职场人在变革中寻找各自的位置。剧中既有商场的尔虞我诈，也有普通家庭的温情牵挂。城市的每一条脉络里，都跳动着真实而鲜活的脉搏。",
    tags: ["都市", "职场", "家庭"],
    hot: 82,
  },
  {
    id: "t3",
    title: "刑警荣耀",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20police%20officer%20standing%20in%20a%20dim%20interrogation%20room%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-03&orientation=portrait",
    year: 2024,
    genres: ["犯罪", "悬疑", "警匪"],
    region: "中国大陆",
    rating: 8.6,
    episodes: 32,
    director: "五百",
    actors: ["张译", "于和伟", "李现"],
    synopsis: "刑侦支队迎来一位风格强硬的新队长，与队里经验丰富的老刑警碰撞不断。一桩跨越多年的系列案件让两人不得不放下成见，联手追查真相。每一次破案，都是对正义最庄严的致敬。",
    tags: ["警匪", "悬疑", "刑侦"],
    hot: 92,
  },
  {
    id: "t4",
    title: "星辰大海",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20spaceship%20crew%20in%20front%20of%20a%20vast%20galaxy%20window%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-04&orientation=portrait",
    year: 2023,
    genres: ["科幻", "冒险"],
    region: "美国",
    rating: 8.4,
    episodes: 24,
    director: "乔纳森·诺兰",
    actors: ["佩德罗·帕斯卡", "艾米莉亚·克拉克", "马赫沙拉·阿里"],
    synopsis: "一艘探索舰带着人类的希望驶向深空，船员们在漫长的航程中面对资源、信仰与信任的重重考验。当信号消失在星海之间，他们必须依靠彼此，才能抵达那片传说中的星辰大海。",
    tags: ["科幻", "太空", "冒险"],
    hot: 89,
  },
  {
    id: "t5",
    title: "归来仍是少年",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20group%20of%20teenagers%20cycling%20down%20a%20tree%20lined%20road%20at%20sunset%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-05&orientation=portrait",
    year: 2024,
    genres: ["青春", "校园", "剧情"],
    region: "中国大陆",
    rating: 8.0,
    episodes: 30,
    director: "刘畅",
    actors: ["张子枫", "白敬亭", "赵今麦"],
    synopsis: "毕业十年后，五位老同学因一场同学会重新聚首。回忆倒带回那个蝉鸣阵阵的夏天，那些关于梦想、友情与遗憾的故事一一浮现。时间改变了容颜，却没有带走少年心中的热望。",
    tags: ["青春", "校园", "怀旧"],
    hot: 81,
  },
  {
    id: "t6",
    title: "医者仁心",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20doctor%20in%20a%20hospital%20corridor%20under%20fluorescent%20light%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-06&orientation=portrait",
    year: 2022,
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    rating: 8.3,
    episodes: 40,
    director: "张黎",
    actors: ["靳东", "海清", "白百何"],
    synopsis: "急诊科每天都在上演生死时速。一位坚持原则的主治医师，在制度的约束与人性的温度之间寻找平衡。每一次抢救背后，都是医者对生命最朴素而坚定的承诺。",
    tags: ["医疗", "都市", "剧情"],
    hot: 80,
  },
  {
    id: "t7",
    title: "豪门风云",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20an%20elegant%20businesswoman%20in%20a%20luxury%20boardroom%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-07&orientation=portrait",
    year: 2023,
    genres: ["商战", "剧情"],
    region: "中国香港",
    rating: 7.9,
    episodes: 30,
    director: "戚其义",
    actors: ["佘诗曼", "林峯", "黄宗泽"],
    synopsis: "家族企业迎来权力更替，几位继承人各怀心思。一场围绕股权的明争暗斗悄然展开，昔日的手足之情在利益面前岌岌可危。谁能笑到最后，谁又将付出代价，一切尚未可知。",
    tags: ["商战", "家族", "剧情"],
    hot: 75,
  },
  {
    id: "t8",
    title: "古宅秘闻",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20dim%20gothic%20mansion%20hallway%20with%20candlelight%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-08&orientation=portrait",
    year: 2024,
    genres: ["悬疑", "惊悚"],
    region: "英国",
    rating: 8.2,
    episodes: 12,
    director: "迈克·弗拉纳根",
    actors: ["凯特·温丝莱特", "汤姆·希德勒斯顿", "奥利维亚·科尔曼"],
    synopsis: "一座偏远的古老宅邸被继承给了一个年轻家庭。随着他们搬入，宅子里尘封多年的秘密逐渐显露。每到午夜，走廊深处便会响起低语。真相，远比想象中更加令人不寒而栗。",
    tags: ["悬疑", "惊悚", "古宅"],
    hot: 87,
  },
  {
    id: "t9",
    title: "青春纪事",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20young%20student%20gazing%20out%20a%20classroom%20window%20in%20soft%20daylight%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-09&orientation=portrait",
    year: 2022,
    genres: ["青春", "爱情"],
    region: "韩国",
    rating: 8.0,
    episodes: 16,
    director: "安畔锡",
    actors: ["金泰梨", "南柱赫", "裴秀智"],
    synopsis: "高三那年，她和他在图书馆的角落相遇。一次偶然的借书，让两颗年轻的心慢慢靠近。面对升学、家庭与未来的选择，他们用最笨拙的方式，记录下这段青涩而真挚的时光。",
    tags: ["青春", "爱情", "校园"],
    hot: 78,
  },
  {
    id: "t10",
    title: "长夜将尽",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20still%20of%20a%20rainy%20city%20street%20at%20night%20with%20a%20lone%20umbrella%20figure%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-tv-10&orientation=portrait",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    rating: 8.5,
    episodes: 28,
    director: "陈正道",
    actors: ["王景春", "咏梅", "荣梓杉"],
    synopsis: "一场持续多年的悬案，牵动着两个家庭的命运。当年幼的目击者长大成人，尘封的记忆开始苏醒。在真相与谎言交织的长夜里，有人选择沉默，也有人选择点亮一盏灯。",
    tags: ["悬疑", "犯罪", "剧情"],
    hot: 90,
  },
];